import { useCallback, useState } from "react";
import { getInvoices, GetInvoicesParams, InvoicesListResponse } from "../actions/getInvoices";

export const useInvoices = () => {
  const [invoices, setInvoices] = useState<InvoicesListResponse>({
    items: [],
    page: 1,
    pageSize: 10,
    totalItems: 0,
    totalPages: 0,
  });

  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const getAllInvoices = useCallback(async (params: GetInvoicesParams = {}) => {
    setLoading(true);
    setError(null);

    try {
      const data = await getInvoices(params);
      setInvoices(data);
    } catch (err: unknown) {
      const message = err instanceof Error ? err.message : "Error fetching invoices";
      setError(message);
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    invoices,
    loading,
    error,
    getAllInvoices,
  };
};
